import React from 'react';

import Metadata from 'components/Metadata/Metadata';
import { ReleaseTypeWrapper } from 'components/base/EntityItem/EntityItem.style';

import {
  StyledList,
  StyledListItem,
  StyledCompareBullet,
  DisplayName,
  CompareItem,
  CompareItemBody,
} from '../CompareLegend.style';
import {
  VerticalLine,
  GorizontalLine,
} from 'components/TopicFilters/TopicFilters.styles';

interface IEntityCompareLegendProps {
  /** The Entity Type e.g. track, release, label */
  entityType?: string;
  /** The Entity IDs in the form of an array, no further entity information is included */
  entityIds?: string[];
  /** Object containing all information for the entities in the Redux cache */
  entitiesById: any;
  /** Should we show a stacked legend for smaller screens */
  isSmallScreen: boolean;
  isLessThan1024px: boolean;
  entityTitle?: string;
  /** The current topic */
  topic: any;
}

/** Displays a list of entities that are being compared */
const EntityCompareLegend: React.FC<IEntityCompareLegendProps> = ({
  entityIds,
  entitiesById,
  entityType,
  isSmallScreen,
  isLessThan1024px,
  entityTitle,
  topic,
}) => {
  const showMediumSize = isLessThan1024px && entityIds && entityIds?.length > 2;
  return (
    // eslint-disable-next-line
    <StyledList isStacked={isSmallScreen}>
      {entityIds &&
        entityIds.map((id, index) => {
          if (!entitiesById[id]) {
            return null;
          }

          const entityData = entitiesById[id];
          const { entity, loading, error } = entityData;

          return (
            <StyledListItem key={id} isStacked={isSmallScreen}>
              <>
                {loading && (
                  <CompareItem>
                    <StyledCompareBullet index={index} />
                    <CompareItemBody>Loading</CompareItemBody>
                  </CompareItem>
                )}
                {!loading && error && (
                  <CompareItem>
                    <StyledCompareBullet index={index} />
                    <CompareItemBody>
                      Loading {entityType} {id} failed
                    </CompareItemBody>
                  </CompareItem>
                )}
                {!loading && entity && (
                  <CompareItem
                    alignItems={
                      entityTitle === 'artists' ? 'center' : undefined
                    }
                  >
                    <StyledCompareBullet
                      index={index}
                      marginTop={
                        entityTitle === 'artists'
                          ? '-3px'
                          : isSmallScreen
                          ? '3px'
                          : undefined
                      }
                    />
                    <CompareItemBody>
                      <DisplayName
                        isExpanded
                        showMediumSize={showMediumSize}
                        isSmallScreen={isSmallScreen}
                      >
                        <div>
                          {topic.includes('social') &&
                          entityType !== 'artist' &&
                          entity.primaryArtist
                            ? entity.primaryArtist.displayName
                            : entity.displayName}
                        </div>
                        {entity?.productType && (
                          <ReleaseTypeWrapper
                            releaseTypeColor="#fff"
                            lineHeigh="12px"
                          >
                            {entity?.productType}
                          </ReleaseTypeWrapper>
                        )}
                      </DisplayName>
                      <Metadata
                        entityType={entity.type}
                        displayName={entity.displayName}
                        primaryArtist={
                          entity.primaryArtist &&
                          entity.primaryArtist.displayName
                        }
                        isGroup={entity.is_group}
                        artistCount={entity.artist_count}
                        showMediumSize={showMediumSize}
                        isSmallScreen={isSmallScreen}
                        isrc_list={entity?.isrc_list}
                        isCompareLegend
                      />
                    </CompareItemBody>
                  </CompareItem>
                )}
              </>
              {!isSmallScreen && (
                <VerticalLine
                  margin={`0 ${
                    index !== entityIds.length - 1
                      ? '0'
                      : showMediumSize
                      ? '15px'
                      : '30px'
                  } 0 ${showMediumSize ? '10px' : '20px'}`}
                />
              )}
            </StyledListItem>
          );
        })}
      {isSmallScreen && <GorizontalLine />}
    </StyledList>
  );
};

export default EntityCompareLegend;
